<ion-header class="ion-no-border premium-header">
  <div class="header-curve"></div>
  <div class="custom-toolbar">
    <div class="toolbar-content">
      <div class="icon-btn" (click)="close()">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </div>
      <div class="title-group">
        <div class="title-main">Registro de Gastos</div>
        <div class="title-sub">Listado de gastos registrados</div>
      </div>
    </div>
  </div>
</ion-header>

<ion-content [fullscreen]="true">

  <!-- LISTADO DE GASTOS -->

  <!-- Premium Collapsible Summary -->
  <div class="summary-section">
    <div class="summary-mini-card" [class.expanded]="showSummaryDetails"
      (click)="showSummaryDetails = !showSummaryDetails">
      <div class="main-info">
        <div class="label-group">
          <span class="mini-label">Total Gastos</span>
          <span class="main-amount">{{ totalGastosAmount() | currency:'USD':'symbol':'1.0-2' }}</span>
        </div>
        <div class="toggle-icon">
          <ion-icon [name]="showSummaryDetails ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
        </div>
      </div>

      <div class="expanded-content" *ngIf="showSummaryDetails">
        <div class="divider"></div>

        <!-- Breakdown Grid -->
        <div class="breakdown-grid" *ngIf="gastosList.length > 0">
          <div class="breakdown-item" *ngFor="let bt of getGastosBreakdown()">
            <span class="bt-type">{{ bt.tipo }}</span>
            <span class="bt-amount">{{ bt.total | currency:'USD':'symbol':'1.0-1' }}</span>
          </div>
        </div>

        <div class="footer-stats">
          <div class="stat-item">
            <ion-icon name="list-outline"></ion-icon>
            <span>{{ gastosList.length }} registros</span>
          </div>
          <div class="stat-item" *ngIf="trabajo">
            <ion-icon name="briefcase-outline"></ion-icon>
            <span>ID: {{ trabajo.id }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Spinner Loading -->
  <div class="loading-state" *ngIf="loading">
    <ion-spinner name="crescent"></ion-spinner>
    <p>Cargando gastos...</p>
  </div>

  <!-- No entries msg -->
  <div class="empty-state" *ngIf="!loading && gastosList.length === 0">
    <div class="empty-icon">
      <ion-icon name="receipt-outline"></ion-icon>
    </div>
    <p>No se han registrado gastos para este trabajo.</p>
  </div>

  <!-- Gastos List (Collapsible / Display) -->
  <div class="workers-section" *ngIf="!loading && gastosList.length > 0">
    <div class="section-header">
      <h3>Lista de Gastos</h3>
    </div>

    <!-- List -->
    <div class="worker-item" *ngFor="let g of gastosList" (click)="editGasto(g)">
      <div class="item-main">
        <div class="avatar" [ngClass]="getAvatarClass(g.dt7)">
          <ion-icon name="receipt-outline"></ion-icon>
        </div>
        <div class="info">
          <h2>{{ g.dt6 }}</h2> <!-- Descripcion -->
          <p>{{ g.dt4 || 'Sin lugar especificado' }}</p> <!-- Lugar -->
        </div>
        <div class="total">
          ${{ g.dt5 | number:'1.2-2' }}
        </div>
      </div>

      <div class="item-footer">
        <div class="tags">
          <span class="tag tag-date">📅 {{ g.dt3 | date:'mediumDate' }}</span>
          <span class="tag tag-type">🏷️ {{ g.dt7 }}</span>
          <span class="tag tag-type" *ngIf="g.dt8"
            style="background:#e8f4f8; color:#0288d1; cursor: pointer; z-index: 2;"
            (click)="viewAttachment(g); $event.stopPropagation()">
            <ion-icon name="attach-outline" style="vertical-align: middle;"></ion-icon>
            Adjunto
          </span>
        </div>
      </div>
    </div>
  </div>

  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button (click)="addNew()" class="fab-btn premium-fab">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>